import { ABOUT } from "../../data/mock";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-cream"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <span className="eyebrow" data-testid="about-eyebrow">About</span>
            <h2
              data-testid="about-heading"
              className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mt-6 text-navy"
            >
              A career built on
              <br />
              <span className="italic text-terracotta">curiosity & care.</span>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-6">
            {ABOUT.paragraphs.map((p, i) => (
              <p
                key={i}
                data-testid={`about-paragraph-${i}`}
                className={`text-lg md:text-[19px] leading-relaxed ${
                  i === 0 ? "text-navy font-medium" : "text-ink-muted"
                }`}
              >
                {p}
              </p>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#E5E0D8] mt-20 border border-[#E5E0D8]">
          {ABOUT.stats.map((s, i) => (
            <div
              key={i}
              data-testid={`about-stat-${i}`}
              className="bg-cream p-8 md:p-10"
            >
              <div className="font-display text-5xl md:text-6xl text-terracotta">
                {s.value}
              </div>
              <div className="mt-3 text-sm uppercase tracking-[0.18em] text-navy font-semibold">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
